import React, { useEffect, useState } from 'react';
import './DealDashboardTimesheet.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { invertColor } from '../../common/util/appUtils'; // Assuming it's available

const convertTime = (seconds) => {
  if (seconds == null || seconds == undefined) {
    return '0 sec';
  }

  const days = Math.floor(seconds / (24 * 60 * 60));
  const hours = Math.floor((seconds % (24 * 60 * 60)) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  let timeStr = '';
  if (days > 0) timeStr += `${days}d `;
  if (hours > 0) timeStr += `${hours}h `;
  if (minutes > 0) timeStr += `${minutes}m `;
  if (secs > 0 || timeStr === '') timeStr += `${secs}s`;

  return timeStr.trim();
};
  function colorNameToHex(color) {
    const ctx = document.createElement("canvas").getContext("2d");
    ctx.fillStyle = color;
    return ctx.fillStyle;
  }
const TaskRow = ({ task, isExpanded, toggleExpand, pipeline }) => {
  let status = task?.TaskFlowObject?.Nodes?.find((k) => k.id == task.TaskStatus)?.data;
  return (
    <tr className="task-row1">
      <td className="column1">
        {task.SubTasks && task.SubTasks.length > 0 ? (
          <button
            className="expand-collapse-btn1"
            onClick={() => toggleExpand(task.TaskROWID)}
            title="Expand/Collapse"
          >
            {isExpanded ? <FontAwesomeIcon icon={faCaretDown} /> : <FontAwesomeIcon icon={faCaretRight} />}
          </button>
        ): <span className='expand-collapse-btnEmpty'></span>}
        <div className="task-name1 Elipsis-Class" title={task.TaskName}>{task.TaskName}</div>
      </td>
      <td className="column1 Elipsis-Class" title={pipeline}>{pipeline}</td>
      <td className="column1">
        <div className="statusDiv1"
          style={{
            background: status?.color || 'lightgray',
            color: invertColor(colorNameToHex(status?.color || 'lightgray'), true),
          }}
        >
          {status?.label}
        </div>
      </td>
      <td className="column1">{convertTime(task.TimeTrackingObject?.totalTime || 0)}</td>
    </tr>
  );
};

const SubtaskRow = ({ subtask, pipeline }) => {
  let status = subtask?.TaskFlowObject?.Nodes?.find((k) => k.id == subtask.TaskStatus)?.data;
  return (
    <tr className="task-row1">
      <td className="column1 Elipsis-Class" style={{ paddingLeft: '30px', textIndent: '34px', textAlign: 'start' }} title={subtask.TaskName}>
        {subtask.TaskName}
      </td>
      <td className="column1 Elipsis-Class" title={pipeline}>{pipeline}</td>
      <td className="column1">
        <div className="statusDiv1"
          style={{
            background: status?.color || 'lightgray',
            color: invertColor(colorNameToHex(status?.color || 'lightgray'), true),
          }}
        >
          {status?.label}
        </div>
      </td>
      <td className="column1">{convertTime(subtask.TimeTrackingObject?.totalTime || 0)}</td>
    </tr>
  );
};

export default function DealDashboardTimesheet({ tasksForDeal }) {
  const [expandedTasks, setExpandedTasks] = useState({});

  const toggleExpand = (TaskROWID) => {
    setExpandedTasks((prevState) => ({
      ...prevState,
      [TaskROWID]: !prevState[TaskROWID],
    }));
  };

  return (
    <div className="timesheet-container1" style={{ height: '38rem', overflow: 'auto' }}>
      <table className="timesheet-table1">
        <thead>
          <tr className="timesheet-header1">
            <th className="column1">Task Name</th>
            <th className="column1">Pipeline Name</th>
            <th className="column1">Task Status</th>
            <th className="column1">Total Time</th>
          </tr>
        </thead>
        <tbody className="timesheet-body1">
          {tasksForDeal.map((pipeline) =>
            pipeline.Tasks.map((task) => {
              const isExpanded = expandedTasks[task.TaskROWID] || false;
              return (
                <React.Fragment key={task.TaskROWID}>
                  <TaskRow
                    task={task}
                    pipeline={pipeline.PipelineName}
                    isExpanded={isExpanded}
                    toggleExpand={toggleExpand}
                  />
                  {isExpanded && task.SubTasks && task.SubTasks.length > 0 &&
                    task.SubTasks.map((subtask) => (
                      <SubtaskRow pipeline={pipeline.PipelineName} key={subtask.TaskROWID} subtask={subtask} />
                    ))}
                </React.Fragment>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}
